/**
 * Demo user list. NOT real authentication — just role/status selection
 * for the May 7 demo. CLAUDE.md §4 states: "No authentication for the
 * demo." Three personas covering the three program-relationship
 * statuses.
 *
 * The status field drives which landing experience the user sees:
 *   - pre-register → 候補者 onboarding flow (existing)
 *   - pre-visit    → planning calendar (new)
 *   - post-visit   → 先輩 trip log (existing Alumni component)
 *
 * Persisting users to DDB is post-demo work; for the demo, hardcoded
 * here so the user-list page renders deterministically and the demo
 * narrative is reproducible.
 */

export type UserStatus = 'pre-register' | 'pre-visit' | 'post-visit';

export interface User {
  id: string;
  display_name: string;
  status: UserStatus;
  age?: number;
  affiliation?: string;
  /** ID of the cohort the user belongs to or is heading to. */
  visit_cohort?: string;
  /** Short context shown on the user-list card. */
  bio: string;
  /** First character used as avatar fallback (no real images for v0.1). */
  avatar_initial: string;
}

export const USERS: User[] = [
  {
    id: 'miki',
    display_name: 'ミキ',
    status: 'pre-register',
    age: 16,
    affiliation: '東京の私立高校・高2',
    bio: '起業に少し興味、英語が不安。応募するか検討中。',
    avatar_initial: 'ミ',
  },
  {
    id: 'sora',
    display_name: 'ソラ',
    status: 'pre-visit',
    age: 19,
    affiliation: '関西の国立大学・2年',
    visit_cohort: 'a26summer',
    bio: '2026年夏のプログラムに参加予定。出発まで3週間で、行きたいセッションを整理中。',
    avatar_initial: 'ソ',
  },
  {
    id: 'takumi',
    display_name: 'タクミ',
    status: 'post-visit',
    age: 21,
    affiliation: '関東の国立大学・3年',
    visit_cohort: 'a25summer2',
    bio: '2025年夏②に参加。帰国後、自分のWhyを整理しながら次の一歩を考えている。',
    avatar_initial: 'タ',
  },
];

export function getUser(id: string): User | undefined {
  return USERS.find((u) => u.id === id);
}

export const STATUS_LABEL: Record<UserStatus, string> = {
  'pre-register': '応募検討中',
  'pre-visit': '出発前(プランニング中)',
  'post-visit': '参加済み',
};

export const STATUS_HINT: Record<UserStatus, string> = {
  'pre-register':
    '行くべきか、自分に合うか、を考えている段階。先輩と話してみる。',
  'pre-visit':
    'プログラムに申込み、出発に向けて何を体験したいかを整理する段階。',
  'post-visit': '体験を残し、次の候補者に渡せるかたちにする段階。',
};
